import { render, staticRenderFns } from "./BaseDataForm.vue?vue&type=template&id=6985bf54"
import script from "./BaseDataForm.vue?vue&type=script&lang=js"
export * from "./BaseDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports